// --------------------------------------------------------------------------------------------------------------------------
// Helper: Event Handler
// This helper is used to trigger and subscribe to custom events within a specific context (not necessarily tied to the DOM)
// --------------------------------------------------------------------------------------------------------------------------

export default class iamotaEventHandler {
    static events = [];

    static subscribeToEvent(event, callback) {
        const existingEvent = iamotaEventHandler.events.find(e => e.event === event);

        // Check if the event already exists or not
        if (existingEvent) {
            
            // Check if the callback already exists
            if (!existingEvent.callbacks.includes(callback)) {
                existingEvent.callbacks.push(callback);
            }
        } else {
            iamotaEventHandler.events.push({ event, callbacks: [callback] });
        }
    }

    static triggerEvent(event, params) {
        const eventObj = iamotaEventHandler.events.find(e => e.event === event);

        if (eventObj) {
            eventObj.callbacks
                .filter(callback => typeof callback === 'function')
                .forEach(callback => callback(event, params));
        }
    }
}